import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  borderRadius,
  primaryColours,
  grid: { spacing, resolution },
} = theme

export const PMBCarouselExplainerStyles = styled.div`
  .carousel-wrapper {
    display: flex;
    flex-direction: column;

    .carousel-image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      .slide-image {
        border-radius: ${borderRadius.double} ${borderRadius.double} 0 0;
        min-width: 100%;
        height: auto;
      }
    }

    .carousel-content-container {
      width: 100%;
      background-color: ${primaryColours.white.main};
      padding: ${spacing.md}px ${spacing.base}px;
      border-radius: 0 0 ${borderRadius.double} ${borderRadius.double};

      .indicator-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon__arrow-left,
        .icon__arrow-right {
          cursor: pointer;
        }
      }

      .content-title {
        margin: ${spacing.base}px 0 ${spacing.s}px;
        font-size: 18px;
      }

      .content-text {
        margin-top: ${spacing.s}px;
        margin-bottom: 0;
        color: ${primaryColours.aubergine.main};
        font-size: 18px;
      }
    }
  }

  @media (max-width: ${resolution.tablet.width}px) {
    .carousel-wrapper {
      .carousel-image-container {
        width: 100%;
        height: auto;
      }
    }
  }

  @media (min-width: ${resolution.tablet.width}px) {
    .carousel-wrapper {
      flex-direction: row;

      .carousel-content-container {
        border-radius: 0 ${borderRadius.double} ${borderRadius.double} 0;
      }

      .carousel-image-container {
        min-width: 328px;
        height: auto;
        .slide-image {
          border-radius: ${borderRadius.double} 0 0 ${borderRadius.double};
        }
      }
    }
  }

  @media (min-width: ${resolution.desktop.width}px) {
    .carousel-wrapper {
      .carousel-image-container {
        min-width: 411.5px;
      }
    }
  }
`
